"use strict";

var LoggerInstance = require("js-logger").get("ApplePayHelper");

var CheckoutActions = require("./CheckoutActions");

var AccountFormHelper = require("../accountComponents/AccountFormHelper");

var ApplePayApi = require("../api/ApplePayApi");

var Spinner = require("../client/Spinner");

var CheckoutHelper = require("../commonComponents/CheckoutHelper");

var Constants = require("../designer/Constants");

var BootstrapPrompt = require("../shared/BootstrapPrompt");

module.exports = {
	initialize: function () {
		// Once the page has loaded, if Apple has removed the Apple Pay Button or PaymentRequest is not defined, we should remove the component.
		document.addEventListener("DOMContentLoaded", () => {
			setTimeout(() => {
				var applePayConfiguration = CheckoutActions.getApplePayConfiguration();
				var $applePayButton = $("apple-pay-button");

				if (applePayConfiguration.enableApplePay === "N" || $applePayButton.css("display") === "none" || !window.PaymentRequest) {
					$("[data-component='applePay']").remove();
				}
			}, 0);
		});
	},

	onApplePayButtonClicked: function () {
		Spinner.showSpinner();

		var components = CheckoutActions.getComponentsForCheckoutValidation(Constants.CHECKOUT_VALIDATION_TYPES.ALTERNATIVE_BUTTON_CHECKOUT);
		var addressStandardizationOptions = { primaryAddressFormName: AccountFormHelper.getPrimaryAddressFormName() };
		var applePayErrorMessages = CheckoutActions.getApplePayDisplayMessages();
		applePayErrorMessages.sessionErrorLogMessage = "Apple Pay Error: Unable to start a valid payment session.";
		applePayErrorMessages.paymentCreationErrorLogMessage = "Apple Pay Error: Unable to create valid payment information for processing the selected payment.";

		CheckoutActions.validateCheckout(null, { components }, addressStandardizationOptions).always(validationResult => {
			if (!validationResult.isValid) {
				// Our normal validation error messages have already been displayed at this point.
				Spinner.removeSpinner();
				return;
			}

			CheckoutHelper.getCheckoutData().always(dataToSend => {
				if (!dataToSend) {
					// Our normal data collection error messages have already been displayed at this point.
					Spinner.removeSpinner();
					return;
				}

				// We have to perform a reCAPTCHA challenge before displaying the Payment Screen
				CheckoutActions.validateWithReCAPTCHA().always(validationResult => {
					if (validationResult.reCAPTCHAResponseToken) {
						dataToSend.reCAPTCHAResponseToken = validationResult.reCAPTCHAResponseToken;
					}

					const paymentRequest = this.getApplePayPaymentRequest(applePayErrorMessages);
					if (paymentRequest) {
						this.startApplePayPaymentSession(paymentRequest, applePayErrorMessages);
						this.performApplePayCheckout(paymentRequest, dataToSend, applePayErrorMessages);
					}
				});
			});
		});
	},

	getApplePayPaymentRequest: function (applePayErrorMessages) {
		var applePayConfiguration = CheckoutActions.getApplePayConfiguration();

		const paymentMethodData = [{
			"supportedMethods": "https://apple.com/apple-pay",
			"data": {
				"version": 13,
				"merchantIdentifier": applePayConfiguration.merchantIdentifier,
				"merchantCapabilities": [
					"supports3DS"
				],
				"supportedNetworks": [ // This is all Apple's supported networks.
					"amex",
					"cartesBancaires",
					"chinaUnionPay",
					"dankort",
					"discover",
					"eftpos",
					"electron",
					"elo",
					"girocard",
					"interac",
					"jcb",
					"mada",
					"maestro",
					"masterCard",
					"mir",
					"privateLabel",
					"visa",
					"vPay"
				],
				"countryCode": applePayConfiguration.merchantCountry
			}
		}];

		const paymentDetails = {
			"total": {
				"type": "final",
				"label": applePayConfiguration.merchantDisplayName,
				"amount": {
					"value": CheckoutActions.getTotalAmount(),
					"currency": CheckoutActions.getCurrency()
				}
			}
		};

		const paymentOptions = {
			"requestPayerName": false,
			"requestBillingAddress": false,
			"requestPayerEmail": false,
			"requestPayerPhone": false,
			"requestShipping": false,
			"shippingType": "shipping"
		};

		try {
			return new PaymentRequest(paymentMethodData, paymentDetails, paymentOptions);
		} catch (exception) {
			this.handleApplePayError(exception, applePayErrorMessages.paymentUnavailable);
			return null;
		}
	},

	startApplePayPaymentSession: function (paymentRequest, applePayErrorMessages) {
		paymentRequest.onmerchantvalidation = (event) => {
			ApplePayApi.createApplePayPaymentSession(event.validationURL).then(paymentSessionResponse => {
				var session = paymentSessionResponse && paymentSessionResponse.paymentSession;
				if (session) {
					event.complete(session);
				} else {
					paymentRequest.abort();
					this.handleApplePayError(applePayErrorMessages.sessionErrorLogMessage, applePayErrorMessages.paymentUnavailable);
				}
			}).catch(exception => {
				paymentRequest.abort();
				this.handleApplePayError(applePayErrorMessages.sessionErrorLogMessage, applePayErrorMessages.paymentUnavailable);
			});
		};
	},

	performApplePayCheckout: function (paymentRequest, dataToSend, applePayErrorMessages) {
		// Display the Payment Screen
		paymentRequest.show().then((paymentResponse) => {
			var paymentInformation = this.getApplePayPaymentInformation(paymentResponse);
			if (paymentInformation) {
				// Submit Checkout
				CheckoutActions.processPreTokenizedPaymentCheckout(
					paymentInformation,
					dataToSend,
					(successCallback) => { this.dismissPaymentSheet(paymentResponse, "success") },
					(failureCallback) => { this.dismissPaymentSheet(paymentResponse, "fail") }
				);
			} else {
				this.handleApplePayError(applePayErrorMessages.paymentCreationErrorLogMessage, applePayErrorMessages.tokenizationFailed);
				this.dismissPaymentSheet(paymentResponse, "fail");
			}
		}).catch(exception => {
			// If the user manually closed (aborted) the Payment Screen, we should skip the alert message.
			var shouldSkipAlert = exception && exception.name === "AbortError";
			this.handleApplePayError(exception, applePayErrorMessages.paymentUnavailable, shouldSkipAlert);
		});
	},

	getApplePayPaymentInformation: function (paymentResponse) {
		var paymentInformation = null;

		var token = paymentResponse && paymentResponse.details && paymentResponse.details.token;
		if (token) {
			var paymentMethod = token.paymentMethod || {};

			var hostedPageToken = this.createHostedPageTokenFromApplePayResponseToken(token);
			var cardType = (paymentMethod.network || "").toUpperCase();
			var last4Digits = (paymentMethod.displayName || "").slice(-4);
			var type = "CC";

			// Apple Pay provides data for the following fields in the CombinedPaymentDto/PaymentContainer:
			paymentInformation = {
				hostedPageToken,
				cardType,
				last4Digits,
				type
			};
		}

		return paymentInformation;
	},

	createHostedPageTokenFromApplePayResponseToken: function (token) {
		var paymentData = token && token.paymentData || {};
		var data = paymentData.data || "";
		var signature = paymentData.signature || "";

		var header = paymentData.header || {};
		var ephemeralPublicKey = header.ephemeralPublicKey || "";
		var transactionId = header.transactionId || "";
		var publicKeyHash = header.publicKeyHash || "";

		return `APPLE_PAY|${data}&ectype=apple&ecsig=${signature}&eckey=${ephemeralPublicKey}&ectid=${transactionId}&echash=&ecpublickeyhash=${publicKeyHash}`;
	},

	handleApplePayError(logMessage, errorMessage, shouldSkipAlert) {
		if (!shouldSkipAlert) {
			LoggerInstance.error(logMessage);
			BootstrapPrompt.alert(errorMessage);
		}
		Spinner.removeSpinner();
	},

	dismissPaymentSheet: function (paymentResponse, completionStatus) {
		paymentResponse.complete(completionStatus);
	}
};